import { GetStaticProps } from 'next/types';
import { PianoPageConfig } from 'services/Piano/entities/PianoPageConfig';
import { AdvancedSearchPage } from 'pages/AdvancedSearch/AdvancedSearchPage';
import { HeaderNav } from 'interfaces/navigation/Header';
import { mockAdvancedSearchHeadData } from 'utils/metaDataUtils/headData';
import { ArcSpanPageConfig } from 'services/ArcSpan/entities';
import { setarcSpanPageConfig } from 'services/ArcSpan';
import { setMockPianoConfig } from 'services/Piano';
import mockPageData from 'lib/mockData/page-data';
import { PageAdConfig } from 'interfaces/ads/Ad';
import setAdvSearchPageAdConfig from 'services/Ad/config/setAdvSearchPageAdConfig';
import getFooter from 'api/Footer/getFooter';
import handleStaticPropsError from 'utils/handleStaticPropsError';
import getMenu from 'api/Header/getMenu';
import { safeAsync } from 'utils/errorHandlingUtils';
import fallbackData from 'lib/fallbackData/commonData';

const AdvancedSearcNextPage: any = () => <AdvancedSearchPage />;

export default AdvancedSearcNextPage;

export const getStaticProps: GetStaticProps = async () => {
  try {
    const menu: HeaderNav = await safeAsync(
      () => getMenu('LEFT_MENU_COM', 'RIGHT_MENU_COM', 'TOPIC_NAVIGATION_COM', 'own', null),
      fallbackData.headerNav,
    );

    const footer = await safeAsync(() => getFooter(), fallbackData.footer);
    const pageAdConfig: PageAdConfig = setAdvSearchPageAdConfig();
    const arcSpanPageConfig: ArcSpanPageConfig = setarcSpanPageConfig(mockPageData);
    const pianoPageConfig: PianoPageConfig = setMockPianoConfig();

    return {
      props: {
        arcSpanPageConfig,
        footer,
        headData: mockAdvancedSearchHeadData,
        headerNav: menu,
        pageAdConfig,
        pianoPageConfig,
      },
      revalidate: 300,
    };
  } catch (e) {
    return handleStaticPropsError(e as Error);
  }
};
